// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.competition-edit[data-v-df28a9a4] {\n    width: 100%;\n    margin-left: 0;\n}\n@media (min-width: 992px) {\n.competition-edit[data-v-df28a9a4] {\n        margin-left: 30px;\n}\n}\n.admin-header__loading-state[data-v-df28a9a4] {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
